export const storyblokProductFilterRootPaths = [
    '/products',
    '/custom-printed-packaging',
    '/blank-packaging',
] as const;
